import { getPreviousQuarter } from "../../utils/dateUtils";

export const HOME_CONSTANTS = {
  BREADCRUMB: {
    TITLE: "My Applications",
    PATH: "/",
  },
  DEFAULT_USER: {
    USERNAME: "",
  },
  QUERY_PARAMS: {
    DEFAULT_YEAR: getPreviousQuarter().year.toString(),
    DEFAULT_QUARTER: getPreviousQuarter().quarter.toString(),
  },
  STATES: {
    LOADING: {
      MESSAGE: "Loading applications...",
    },
    ERROR: {
      MESSAGE: "Error loading applications: ",
    },
    EMPTY: {
      TITLE: "No applications found",
      SUBTITLE: "You haven't submitted any bonus applications yet.",
      ICON: {
        SIZE: "w-12 h-12",
        COLOR: "text-gray-400",
      },
    },
  },
  LAYOUT: {
    MAX_WIDTH: "max-w-9xl",
    PADDING: "px-4 sm:px-6 lg:px-8",
    SPACING: {
      BREADCRUMB: "mb-6",
      CONTENT: "space-y-4",
    },
  },
  HEADER: {
    COUNTER_TEXT: "applications",
  },
};